import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {map, Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { Docks } from '../models/Docks';

@Injectable({
    providedIn: 'root'
})
export class DocksService {

    private readonly docksUrl=environment.docksUrl;

    constructor(private readonly httpClient:HttpClient) { }

    getDocksInfo(): Observable<Docks[]> {
      console.log(this.docksUrl);
      return this.httpClient.get<Docks[]>(this.docksUrl).pipe(map(
        allDocks => {
          return allDocks.map((allDocks) => {
            return Docks.transformDockData(allDocks);
          })
        })
      );
    }

    saveDocksInfo(docks: Docks): Observable<Docks>{
        return this.httpClient.post<Docks>(this.docksUrl, docks);
    }


    updateDocks(editedDock: Docks): Observable<Docks> {
        return this.httpClient.put<Docks>(this.docksUrl, editedDock);
    }
}
